import { appSettings } from '@/settings/app-settings';

import createHttpClient from './http-client';

const httpClient = createHttpClient(appSettings.api.ASSET_MANAGER_URL || '');

export async function fetchTemplates(api: any, type?: number) {
  try {
    const response = await httpClient.get(`${api.ASSET_MANAGER_URL}/asset/fetch-templates`, {
      params: { type: type },
    });
    return response;
  } catch (error: any) {
    console.log('>>> error fetching template', error.message);
    throw error;
  }
}

export async function CreateWithTemplate(api: any, payload: any) {
  try {
    const response = await httpClient.post(`${api.ASSET_MANAGER_URL}/asset/create-with-template`, payload);
    return response;
  } catch (error: any) {
    console.log('>>> error creating with template', error.message);
    throw error;
  }
}
